//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CardPropertyGeoPointEditor from '../Card/CardPropertyGeoPointEditor.vue'
import { settingsGUI } from '../../pages/main/sections/UserSettings/UserSettingsGUI.js'

export default {
  name: 'GeoPointField',
  components: {
    CardPropertyGeoPointEditor
  },
  mixins: [settingsGUI],
  props: {
    value: {
      type: [Object, Array],
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    labelColor: {
      type: String,
      default: 'black'
    },
    placeholder: {
      type: String,
      default: undefined
    },
    clearable: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    editorTile: {
      type: String,
      default: 'Координаты'
    }
  },
  data: () => {
    return {
      editorOpened: false,
      editorValue: null,
      editorValueValid: false
    }
  },
  computed: {
    coordsRaw: function () {
      if (this.value) {
        return [[this.value.lon, this.value.lat]] // TODO
      }
      return null
    },
    coordsText: function () {
      if (this.coordsRaw && this.coordsRaw.length) {
        return this.formatCoords(this.coordsRaw[0])
      }
      return null
    }
  },
  methods: {
    onClear: function () {
      this.$emit('input', null) // TODO
    },
    onEdit: function () {
      this.editorValue = this.coordsRaw && this.coordsRaw.length ? [this.coordsRaw[0].slice()] : [[null, null]]
      this.editorOpened = true
    },
    onApplyChanges: function () {
      this.$emit('input', this.editorValue ? { lon: this.editorValue[0][0], lat: this.editorValue[0][1] } : null) // TODO
      this.editorOpened = false
    }
  }
}
